import React, {useEffect, useState, useRef} from "react";
import GenericTemplate from "../../../templates/GenericTemplate";
import {apollo_useStyles, options_state, valueToOption} from "../../../atom/Apollo_styles";
import {
  accountdetailapollo_path,
  zeus_ad_account,
  budget_path
} from "../../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloBreadcrumbs} from "../../../atom/Apollo_Breadcrumbs";
import {ZeusAccountDetail} from "../../../organism/ACCOUNT/AccountModel";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {ApolloContext} from "../../../atom/Apollo_Context";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import axios from "axios";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {options_industory} from "../../../atom/Apollo_industory_options";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {BLANK, INIT_NUMBER, INIT_STR, INIT_BOOL, MSG} from "./common/CommonConst";

import {ApolloEventRecord, LogData, ItemList} from "../../../atom/Apollo_EventRecord";

const INIT_ACCOUNT = {
  id: INIT_NUMBER,
  name: INIT_STR,
  url: INIT_STR,
  status: INIT_NUMBER,
  billingCompanyId: INIT_NUMBER,
  commonAccountId: INIT_NUMBER,
  budgetLimit: INIT_NUMBER,
  advertiserName: INIT_STR,
  lastUpdateUserId: INIT_NUMBER,
  lastUpdateUserName: INIT_STR,
  isApproval: INIT_BOOL,
  industryId: INIT_NUMBER,
  createdAt: INIT_STR,
  updatedAt: INIT_STR,
}

/*
    画面名：アカウント詳細（Ｚｅｕｓ）
 */
const AccountDetailZeus: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const QUERY_NAME_1 = "type";  // クエリパラメータ名
  const QUERY_NAME_2 = "month"; // クエリパラメータ名
  
  const QUERY_TYPE_1 = "bu";  // 予算管理詳細から
  const query1 = new URLSearchParams(useLocation().search);
  const queryType = query1.has(QUERY_NAME_1) ? query1.get(QUERY_NAME_1) : "";
  const budgetMonth1 = query1.has(QUERY_NAME_2) ? query1.get(QUERY_NAME_2) : moment().format("YYYYMM");
  
  const {accountgroupid, accountid, platformaccountid} = useParams();

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 11,
    breadId: 1,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

   const handelGoback = () => {
    if (queryType === QUERY_TYPE_1) {
      const url = budget_path + "/" + accountid + "/" + budgetMonth1;
      history.push(url);
    } else {    
      history.push(accountdetailapollo_path + accountgroupid + "/" + accountid);
    }
  };

  return (
    <GenericTemplate title="">
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom>
            </Typography>
            <Detail/>
           </CardContent>
          <CardActions className={classes.cardaction}>
            <Button
              variant="contained"
              color="primary"
              onClick={handelGoback}
              className={classes.button}
            >
              戻る
            </Button>
          </CardActions>
        </Card>
      </React.Fragment>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

function Detail() {
  const classes = apollo_useStyles();

  const {platformaccountid} = useParams();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [accountDetail, setAccountDetail] = useState<ZeusAccountDetail>(INIT_ACCOUNT);
  const processing = useRef(false);

  const products = [
    {id:'id', name: 'パフォーマンス広告アカウントID', desc: '', value: accountDetail?.id},
    {id:'name', name: 'パフォーマンス広告アカウント名', desc: '', value: accountDetail?.name},
    {id:'advertiserName', name: '広告主名', desc: '', value: accountDetail?.advertiserName},
    {
      id:'industryId', 
      name: '業種',
      desc: '',
      value: accountDetail?.industryId ? valueToOption(accountDetail?.industryId, options_industory).label : ""
    },
    {id:'url', name: 'サイトURL', desc: '', value: accountDetail?.url},
    {id:'billingCompanyId', name: '請求ID', desc: '', value: accountDetail?.billingCompanyId},
    {
      id:'budgetLimit', 
      name: '月額上限予算(当月)',
      desc: '',
      value: accountDetail?.budgetLimit ? "￥" + accountDetail?.budgetLimit.toLocaleString() : ""
    },
    {
      id:'status', 
      name: 'ステータス',
      desc: '',
      value: accountDetail?.status ? valueToOption(accountDetail?.status, options_state).label : ""
    },
    {
      id:'isApproval', 
      name: '承認状況',
      desc: '',
      value: accountDetail?.isApproval !== undefined ? accountDetail?.isApproval === true ? "承認" : "非承認" : ""
    },
    {
      id:'createdAt', 
      name: '作成日時',
      desc: '',
      value: accountDetail?.createdAt ? moment(accountDetail?.createdAt).format("YYYY-MM-DD HH:mm") : ""
    },
    {
      id:'updatedAt', 
      name: '更新日時',
      desc: '',
      value: accountDetail?.updatedAt ? moment(accountDetail?.updatedAt).format("YYYY-MM-DD HH:mm") : ""
    },
  ];

  useEffect(() => {
    const url = process.env.REACT_APP_API_ENDPOINT + zeus_ad_account + platformaccountid;
    axios.get(url,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
      }).then((response) => {
      setAccountDetail(response.data);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "データの取得に失敗しました"
        }
      });
    });
  }, []);

  const handleChange = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;

    const updAccount: ZeusAccountDetail = {
      ...accountDetail,
    };
    switch (accountDetail.status) {
      case 1:
        updAccount.status = 2;
        break;
      case 2:
        updAccount.status = 1;
        break;
    }

    // 実行時ログ
    let itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(accountDetail.status, options_state).label,
        afterValue: valueToOption(updAccount.status, options_state).label,
      },
    ]
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "パフォーマンス広告アカウント詳細画面",
      category: "アカウント管理",
      actionType: "更新",
      targetID: accountDetail.id + "",
      targetName: accountDetail.name,
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${zeus_ad_account}${platformaccountid}`;
    await ApolloAxios.patch(url, updAccount)
      .then((response) => {
        const res: ApiResponse = response.data
        if (isSuccessApi(res.resultCode)) {
          isSuccess = true;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: `${MSG.SUCCESS_UPD_STATUS}`
            }
          });
          setAccountDetail(res.result)
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERR_UPD_STATUS}${res.message ?? BLANK}`
            }
          });
        }
      })
      .catch((err) => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERR_UPD_STATUS}${err?.errmsg ?? BLANK}`
          }
        });
      })
      .finally(() => {
        // 実行結果ログ
        const resultLog: LogData = {
          ...executionLog,
          eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          logType: "result",
          result: isSuccess? "成功" : "失敗",
        }
        ApolloEventRecord(resultLog);

        processing.current = false;
      });
  }

  return (
    <React.Fragment>
      <Grid container spacing={3} style={{marginBottom: "5px"}}>
        {products?.map((product, index) => (
          <React.Fragment key={index}>
            <Grid item xs={6}>
              <Typography>{product.name}</Typography>
            </Grid>
            {IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN) && product.id === 'status' && accountDetail?.status
            ? <React.Fragment>
                <Grid item xs={1}>
                  <Typography>{product.value}</Typography>
                </Grid>
                <Grid item xs={5}>
                  <Button
                    className={classes.buttonTop}
                    variant="contained"
                    color="primary"
                    onClick={handleChange}
                    disabled={processing.current}
                  >
                    {accountDetail.status === 1 && "一時停止"}
                    {accountDetail.status !== 1 && "有効"}
                  </Button>
                </Grid>
              </React.Fragment>
            : <Grid item xs={6}>
                <Typography>{product.value}</Typography>
              </Grid>
            }
          </React.Fragment>
        ))}
      </Grid>
    </React.Fragment>
  );
}

export default AccountDetailZeus;
